<template>
  <transition name="aoform-error">
    <div class="aoform__errormessage">
      <h2 class="aoform__title aoform__title_altspace">Упс! <br>Что-то пошло не так!</h2>
      <p v-if="customErrorTextLength() > 0">
        <span v-for="error in getErrorslList()" :key="error.message" class="aoform__subtitle">{{error.message}}<br></span>
      </p>
      <p v-else class="aoform__subtitle">Приносим свои извинения! На сервере ведуться технические работы. попробуйте обратится к сервису позже.</p>
      <Filler />
      <FormBtn @click.native="$store.commit('cancelError')">Вернуться назад</FormBtn>
    </div>
  </transition>
</template>

<script>
import FormTitles from '@/mixins/FormTitles.vue'
import Filler from '@/components/Filler.vue'
import FormBtn from '@/components/FormBtn.vue'

export default {
  components: {Filler, FormBtn},
  methods:{
    customErrorTextLength(){
      console.log(this.$store.state.customErrorText);
      return this.$store.state.customErrorText.length
    },
    getErrorslList(){
      console.log(this.$store.state.customErrorText);
      return this.$store.state.customErrorText
    }

  },
  mixins: [FormTitles]
}
</script>

<style lang="sass">
.aoform__errormessage
  background: colors.$background
  display: flex
  flex-direction: column
  width: 100%
  min-width: 100%
  position: absolute
  top: calc(var(--formpadding) + var(--closebtn-height))
  bottom: 0
  left: 0
  right: 0
  padding: 0 var(--formpadding) var(--formpadding)
  animation: aoform-error-enter .3s ease-out
.aoform-error-enter,.aoform-error-leave-to
  opacity: 0
  transform: scale(1.1)

.aoform-error-enter-active, .aoform-error-leave-active
  transition: .3s ease-out
@keyframes aoform-error-enter
  0%
    opacity: 0
    transform: scale(1.1)
  100%
    opacity: 1
    transform: none
</style>